module.exports = __webpack_public_path__ + "img/547-42dfb3.png";